import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ProjectsPage from "../pages/projects/page";
import ProjectDetailPage from "../pages/project-detail/page";
import CrewPage from "../pages/crew/page";
import CrewDetailPage from "../pages/crew-detail/page";
import CustomersPage from "../pages/customers/page";
import CustomerDetailPage from "../pages/customer-detail/page";
import TimeClockPage from "../pages/timeclock/page";
import MoverAppPage from "../pages/mover-app/page";
import BookingsPage from "../pages/bookings/page";
import PaymentsPage from "../pages/payments/page";
import FeedbackPage from "../pages/feedback/page";
import SiteHomePage from "../pages/site-home/page";
import SiteServicesPage from "../pages/site-services/page";
import SiteServiceDetailPage from "../pages/site-service-detail/page";
import SiteCheckoutPage from "../pages/site-checkout/page";
import SiteOrderConfirmationPage from "../pages/site-order-confirmation/page";
import SiteAboutPage from "../pages/site-about/page";
import SiteContactPage from "../pages/site-contact/page";
import LoginPage from "../pages/auth/login";
import SignupPage from "../pages/auth/signup";
import ResetPasswordPage from "../pages/auth/reset-password";
import ProfilePage from "../pages/profile/page";
import SettingsPage from "../pages/settings/page";

const routes: RouteObject[] = [
  { path: "/", element: <SiteHomePage /> },
  { path: "/dashboard", element: <Home /> },
  { path: "/profile", element: <ProfilePage /> },
  { path: "/settings", element: <SettingsPage /> },
  { path: "/projects", element: <ProjectsPage /> },
  { path: "/projects/:id", element: <ProjectDetailPage /> },
  { path: "/crew", element: <CrewPage /> },
  { path: "/crew/:id", element: <CrewDetailPage /> },
  { path: "/customers", element: <CustomersPage /> },
  { path: "/customers/:id", element: <CustomerDetailPage /> },
  { path: "/timeclock", element: <TimeClockPage /> },
  { path: "/m", element: <MoverAppPage /> },
  { path: "/m/timeclock", element: <MoverAppPage /> },
  { path: "/m/:token", element: <MoverAppPage /> },
  { path: "/bookings", element: <BookingsPage /> },
  { path: "/payments", element: <PaymentsPage /> },
  { path: "/feedback", element: <FeedbackPage /> },
  { path: "/site", element: <SiteHomePage /> },
  { path: "/site/services", element: <SiteServicesPage /> },
  { path: "/site/services/:id", element: <SiteServiceDetailPage /> },
  { path: "/site/checkout/:id", element: <SiteCheckoutPage /> },
  { path: "/site/order-confirmation/:id", element: <SiteOrderConfirmationPage /> },
  { path: "/site/about", element: <SiteAboutPage /> },
  { path: "/site/contact", element: <SiteContactPage /> },
  { path: "/login", element: <LoginPage /> },
  { path: "/signup", element: <SignupPage /> },
  { path: "/reset-password", element: <ResetPasswordPage /> },
  { path: "*", element: <NotFound /> },
];

export default routes;